import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import {
  DataGrid,
  GridToolbar,
  GridColDef,
  DataGridProps,
  GridToolbarQuickFilter,
  GridPaginationModel,
  GridRowSelectionModel,
} from '@mui/x-data-grid';
import { useState } from 'react';

const $DataGrid = styled(DataGrid)(({ theme }) => ({
  '& .MuiSelect-select': {
    fontSize: '0.79rem !important',
  },
}));

type DataTableProps<T> = {
  checkboxSelection?: boolean;
  columns: GridColDef[];
  height?: number;
  pageSize?: number;
  rows: T[];
  selections?: any;
  customToolbar?: boolean;
  loading?: boolean;
  setRowId?: React.Dispatch<React.SetStateAction<any>>;
  setSelections?: React.Dispatch<React.SetStateAction<GridRowSelectionModel>>;
  onRowClick?: (data) => void;
  customStyles?: object;
} & DataGridProps;

function CustomToolbar() {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', padding: '0.5rem' }}>
      <GridToolbarQuickFilter />
    </Box>
  );
}
function DataTable<T extends object>({
  checkboxSelection = true,
  columns,
  height,
  pageSize,
  rows,
  selections,
  setRowId,
  setSelections,
  onRowClick,
  customToolbar = false,
  customStyles = {},
  loading,
  ...rest
}: DataTableProps<T>) {
  const [rowsSize, setRowsSize] = useState(pageSize || 15);
  const [page, setPage] = useState(0);

  const handlePageSizeChange = ({ pageSize, page }: GridPaginationModel) => {
    setPage(page);
    setRowsSize(pageSize);
  };

  return (
    <Box
      sx={{
        height: height ? height : 420,
        width: '100%',
        '& .super-app-theme--header': {
          backgroundColor: '#1976D2',
        },
      }}
    >
      <$DataGrid
        {...rest}
        rows={rows}
        columns={columns}
        paginationModel={{ pageSize: rowsSize, page }}
        onPaginationModelChange={handlePageSizeChange}
        pageSizeOptions={[10, 20]}
        slots={{ toolbar: customToolbar ? CustomToolbar : GridToolbar }}
        checkboxSelection={checkboxSelection}
        disableRowSelectionOnClick
        loading={loading}
        slotProps={{
          toolbar: {
            showQuickFilter: true,
            csvOptions: { disableToolbarButton: true },
            printOptions: { disableToolbarButton: true },
            quickFilterProps: { debounceMs: 500 },
            ...rest.slotProps?.toolbar,
          },
        }}
        onCellEditStart={(params) => {
          return setRowId?.(params.id);
        }}
        onRowSelectionModelChange={(selections) => {
          setSelections?.(selections);
        }}
        rowSelectionModel={selections}
        onRowClick={(data) => {
          onRowClick?.(data.row);
        }}
        sx={{ ...customStyles }}
      />
    </Box>
  );
}

export default DataTable;
